module.exports = __webpack_public_path__ + "img/logoDH.2e3a0f67.jpg";